<template>
    <div>
        <Line :data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale } from 'chart.js';

// Registramos los componentes de Chart.js
ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale);

export default {
    name: 'Grafica',
    components: {
        Line
    },
    data() {
        return {
            // Definimos los datos de las dos curvas
            chartData: {
                labels: [
                    '01/01/2025', '03/01/2025', '10/01/2025', '11/01/2025', '13/01/2025', '17/01/2025',
                    '20/02/2025', '21/02/2025', '22/02/2025'
                ], // Fechas combinadas de ambas curvas
                datasets: [
                    {
                        label: 'Curva 1', // Primera curva
                        borderColor: 'rgb(75, 192, 192)',
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        data: [10, null, 12, null, 12.5, null, 13, null, 15], // Valores de la primera curva
                        fill: true,
                        tension: 0.4
                    },
                    {
                        label: 'Curva 2', // Segunda curva
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        data: [null, 5, null, 10, null, 11, null, 20, null], // Valores de la segunda curva
                        fill: true,
                        tension: 0.4
                    }
                ]
            },
            // Opciones de la gráfica
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Fecha'
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Valor'
                        },
                        min: 0
                    }
                }
            }
        };
    }
};
</script>

<style scoped>
div {
    position: relative;
    height: 400px;
    width: 100%;
}
</style>